import { Component, OnInit } from '@angular/core';
// -- components --
import { Jc3Block1Component } from './components/jc3-block-1/jc3-block-1.component';
import { Jc3Block2Component } from './components/jc3-block-2/jc3-block-2.component';
import { Jc3Block3Component } from './components/jc3-block-3/jc3-block-3.component';
import { Jc3Block4Component } from './components/jc3-block-4/jc3-block-4.component';
import { Jc3Block5Component } from './components/jc3-block-5/jc3-block-5.component';
import { Jc3Block6Component } from './components/jc3-block-6/jc3-block-6.component';
// services
import { Jc3Service } from '../jc3.service';
// interfaces
import {
    SuccessStoriesResponse,
    SuccessConfResponse,
} from './components/jc3-block-5/interfaces/success-story.interface';

@Component({
    selector: 'app-introduction',
    standalone: true,
    imports: [
        // components
        Jc3Block1Component,
        Jc3Block2Component,
        Jc3Block3Component,
        Jc3Block4Component,
        Jc3Block5Component,
        Jc3Block6Component,
    ],
    templateUrl: './introduction.component.html',
    styleUrl: './introduction.component.scss',
})
export class IntroductionComponent implements OnInit {
    whatsNewData: any = {};
    successStoriesData: SuccessStoriesResponse | null = null;
    successConfData: SuccessConfResponse | null = null;
    esgData = {};
    whyEsgData = {};
    startedjc3Data = {};

    constructor(private _jc3Service: Jc3Service) {}

    ngOnInit() {
        // this.getHomePageData();
        this.getWhatsNewData();
        this.getESGData();
        this.getStartedData();
        this.getSuccessStoriesData();
        // this.getSuccessConfData();
    }

    getHomePageData() {
        this._jc3Service.getHomepage().subscribe({
            next: (res) => true,
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }

    getESGData() {
        this._jc3Service.getWhatIsEsg().subscribe({
            next: (res1: any) => {
                this._jc3Service.getWhatIsEsgCards().subscribe({
                    next: (res2: any) => {
                        this.esgData = { ...res1?.at(0), cards: res2?.at(0) };
                    },
                    error: (error) => {
                        console.error('Error fetching WhatsNew data:', error);
                    },
                });
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });

        this._jc3Service.getWhyEsgMatters().subscribe({
            next: (res1) => {
                this._jc3Service.getWhyEsgMattersCards().subscribe({
                    next: (res2) => {
                        this.whyEsgData = {
                            ...res1?.at(0),
                            cards: res2?.at(0),
                        };
                    },
                    error: (error) => {
                        console.error('Error fetching WhatsNew data:', error);
                    },
                });
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }
    getStartedData() {
        this._jc3Service.getStartedEsgJc3().subscribe({
            next: (res1: any) => {
                this._jc3Service.getStartedEsgJc3Cards().subscribe({
                    next: (res2: any) => {
                        this.startedjc3Data = {
                            ...res1?.at(0),
                            cards: res2?.at(0),
                        };
                    },
                    error: (error) => {
                        console.error('Error fetching WhatsNew data:', error);
                    },
                });
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }
    getWhatsNewData() {
        this._jc3Service.getWhatsNewdata().subscribe({
            next: (res) => {
                const today = new Date();
                this.whatsNewData = res
                    .filter((item) => new Date(item.publishdate) <= today)
                    .sort(
                        (a, b) =>
                            new Date(b.publishdate).getTime() -
                            new Date(a.publishdate).getTime()
                    );
            },

            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }

    getSuccessStoriesData() {
        this._jc3Service.getSmeSuccessStories().subscribe({
            next: (response) => {
                const today = new Date();
                this.successStoriesData = response
                    .filter((item) => new Date(item.publishdate) <= today)
                    .sort(
                        (a, b) =>
                            new Date(b.publishdate).getTime() -
                            new Date(a.publishdate).getTime()
                    );
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }

    getSuccessConfData() {
        this._jc3Service.getSmeSuccessStories().subscribe({
            next: (response) => {
                const today = new Date();
                this.successConfData = response
                    .filter((item) => new Date(item.publishdate) <= today)
                    .sort(
                        (a, b) =>
                            new Date(b.publishdate).getTime() -
                            new Date(a.publishdate).getTime()
                    );
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }
}
